import { GenericOperationState } from '@repo/core'
import { UserInfo } from '@repo/user-types'
import { put, race, take, takeLatest } from 'redux-saga/effects'
import {
  contactDataFormActions,
  editUserDataActions,
  userInfoDataActions,
} from '../../store/actions'

function* initContactDataFormSaga() {
  yield put(userInfoDataActions.getRequest())

  const { response }: { response?: GenericOperationState<UserInfo> } = yield race({
    response: take(userInfoDataActions.getResponse.type),
    clear: take(editUserDataActions.clearData.type),
  })

  if (response && !response.error) {
    yield put(editUserDataActions.initializeData(response.payload))
  }
}

export function* watchInitContactDataForm() {
  yield takeLatest(contactDataFormActions.initContactDataForm.type, initContactDataFormSaga)
}
